// These functions all relate to loading firebase data for a specific Projects

import { db } from "../firebaseConfig";

function getGroupData(groupID) {
  return new Promise((resolve, reject) => {
    db.collection("projects")
      .doc(groupID)
      .get()
      .then(doc => {
        if (doc.exists) {
          resolve({ id: doc.id, ...doc.data() });
        } else {
          reject("Group not found.");
        }
      });
  });
}

function checkAccess(userID, groupID) {
  return new Promise((resolve, reject) => {
    db.collection("projects")
      .doc(groupID)
      .get()
      .then(doc => {
        if (doc.data().members.includes(userID)) {
          resolve();
        } else {
          reject();
        }
      });
  });
}

export { getGroupData, checkAccess };



// WEBPACK FOOTER //
// ./src/scripts/groupFuncs.js